<template>
  <div class="terminal">
    <div class="term-header">
      <span class="dot red"></span><span class="dot yellow"></span><span class="dot green"></span>
    </div>
    <div class="term-body">
      <!-- 渲染已经打完的整行 -->
      <p v-for="(line, idx) in typedLines" :key="'line-' + idx">
        <span class="prompt">$</span> {{ line }}
      </p>

      <!-- 渲染当前正在打字的这一行，光标紧跟其后 -->
      <p>
        <span class="prompt">$</span> {{ currentLine }}<span class="cursor" v-if="isTyping || isDone">█</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typedLines: [], // 已输出的完整行
      currentLine: '', // 当前正在输出的行内容
      allLines: [
        "fraudcounsel_crypto-recovery --init",
        "[OK] connection encrypted (TLS 1.3)",
        "[OK] recovery isolated - confidential",
        "[OK] no private keys requested",
        "[READY] recovery in progress"
      ],
      lineIndex: 0,
      charIndex: 0,
      timer: null,
      isTyping: true,
      isDone: false
    };
  },
  mounted() {
    this.startTyping();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    startTyping() {
      this.timer = setInterval(() => {
        // 如果所有行都打完了
        if (this.lineIndex >= this.allLines.length) {
          clearInterval(this.timer);
          this.isTyping = false;
          this.isDone = true;
          return;
        }

        const currentFullLine = this.allLines[this.lineIndex];

        // 如果当前行还没打完，继续逐字追加
        if (this.charIndex < currentFullLine.length) {
          this.currentLine += currentFullLine.charAt(this.charIndex);
          this.charIndex++;
        }
        // 如果当前行打完了，停顿一下(模拟换行)，然后开始下一行
        else {
          this.typedLines.push(this.currentLine);
          this.currentLine = '';
          this.charIndex = 0;
          this.lineIndex++;
        }
      }, 60); // 60毫秒打一个字，可根据需要调整速度
    }
  }
}
</script>

<style scoped>
.terminal {
  background: rgba(0, 0, 0, 0.85);
  border: 1px solid rgba(0, 229, 255, 0.3);
  backdrop-filter: blur(5px);
  font-family: 'Courier New', monospace;
  color: #00ffa3;
  padding: 15px;
  width: 100%;
  max-width: 500px;
  font-size: 0.9rem;
  text-align: left;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 229, 255, 0.1);
  min-height: 220px;
  /* 固定高度防止高度跳动 */
}

.term-header {
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 10px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.dot.red {
  background: #ff5f56;
}

.dot.yellow {
  background: #ffbd2e;
}

.dot.green {
  background: #27c93f;
}

.term-body p {
  margin: 5px 0;
  line-height: 1.4;
}

.prompt {
  color: #00e5ff;
  margin-right: 5px;
}

/* 光标样式：块状闪烁动画 */
.cursor {
  display: inline-block;
  width: 8px;
  height: 16px;
  background-color: #00ffa3;
  margin-left: 2px;
  vertical-align: middle;
  animation: blink 0.8s step-end infinite;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}
</style>